export default __webpack_public_path__ + "static/media/Activewear.7151ef62.png";